// src/app.config.ts
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations } from '@angular/platform-browser/animations';
import { GrpcCoreModule, GRPC_INTERCEPTORS } from '@ngx-grpc/core';
import { GrpcWebClientModule } from '@ngx-grpc/grpc-web-client';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { provideToastr } from 'ngx-toastr';
import { AuthInterseptorService } from './authentication/interseptor/auth-interseptor.service';
import { environment } from './environments/environment';
import { GRPC_PROVIDERS } from './grpc-providers';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withNoIncrementalHydration()),
    provideAnimationsAsync(),
    ...GrpcCoreModule.forRoot().providers!,
    ...GrpcWebClientModule.forRoot({
      settings: { host: environment.grpcHost }
    }).providers!,
    ...GRPC_PROVIDERS,
    {
      provide: GRPC_INTERCEPTORS,
      useClass: AuthInterseptorService,
      multi: true
    },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        lineNumbersLoader: () => import('ngx-highlightjs/line-numbers'),
        languages: { css: () => import('highlight.js/lib/languages/css') },
        themePath: 'node_modules/highlight.js/styles/a11y-dark.css'
      }
    },
    provideAnimations(),
    provideToastr(),
    provideHttpClient(withXhr()),
    provideTranslateService({
      lang: 'da',
      fallbackLang: 'da',
      loader: provideTranslateHttpLoader({
        prefix: 'i18n/',
        suffix: '.json'
      })
    }),
  ]
};
